"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const useRequest_1 = __importDefault(require("../hooks/useRequest"));
const useAppUserSync_1 = require("../hooks/useAppUserSync");
/**
 *
 * @param props
 * @returns
 */
const AppLoadBranchIO = () => {
    const appUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.appUser);
    const { request } = (0, useRequest_1.default)();
    const currentState = (0, react_1.useRef)(react_native_1.AppState.currentState);
    const { checkUser } = (0, useAppUserSync_1.useAppUserSync)();
    (0, react_1.useEffect)(() => {
        const handleChange = react_native_1.AppState.addEventListener("change", (changedState) => {
            currentState.current = changedState;
            console.log("State changed....!======= ", changedState);
            if (currentState.current === "active" && appUser?.id) {
                // request(syncUser, appUser?.id || "");
            }
        });
        return () => {
            handleChange.remove();
        };
    }, [appUser?.id]);
    (0, react_1.useEffect)(() => {
        if (!appUser?.id) {
            console.log("Check user nav...AppLoadBranchIO");
            checkUser();
        }
    }, [appUser?.id]);
    return null;
};
exports.default = AppLoadBranchIO;
